export default {
    name: "neo-error-message",
    components: {},
    props: ["error"],
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
